module.exports = __webpack_public_path__ + "static/media/img_skill_validation_01.817523c3.png";